import { useEffect, useState } from 'react';
import useGraphqlQuery from '@elementary/common-ui/hooks/useGraphqlQuery';
import { INCIDENT_LIST_GROUP_SUMMARY } from '@elementary/common-ui/constants/queryKeys';
import { getIncidentsSummaryQuery } from '../api';
import type { IncidentGroupSummaryArgs, IncidentListSummary } from '../types';

// Group headers mount and unmount as the user scrolls the virtualized table,
// so wait briefly before fetching to skip headers that are only scrolled past.
const FETCH_DELAY_MS = 200;

const useIncidentGroupSummary = ({
  field,
  groupValue,
  urlFilters,
  baseFilters,
  selectedEnvId,
  selectedIdsHash,
}: IncidentGroupSummaryArgs) => {
  const [isFetchDelayOver, setIsFetchDelayOver] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsFetchDelayOver(true), FETCH_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const { data } = useGraphqlQuery<{ incidentsV2Summary: IncidentListSummary }>(
    {
      queryKey: [
        INCIDENT_LIST_GROUP_SUMMARY,
        selectedEnvId,
        urlFilters,
        baseFilters,
        selectedIdsHash,
        field,
        groupValue,
      ],
      query: getIncidentsSummaryQuery,
      variables: {
        filters: baseFilters,
        incidentFilters: [
          ...(urlFilters || []),
          { property: field, operator: 'equals', value: [groupValue] },
        ],
      },
      enabled: isFetchDelayOver && !!selectedEnvId,
      envId: selectedEnvId,
    },
  );

  return data?.incidentsV2Summary;
};

export default useIncidentGroupSummary;
